import { render, staticRenderFns } from "./TabDeclaracionesDuenoBeneficiario.vue?vue&type=template&id=e5176a52&scoped=true"
import script from "./TabDeclaracionesDuenoBeneficiario.vue?vue&type=script&lang=js"
export * from "./TabDeclaracionesDuenoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./TabDeclaracionesDuenoBeneficiario.vue?vue&type=style&index=0&id=e5176a52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5176a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5176a52')) {
      api.createRecord('e5176a52', component.options)
    } else {
      api.reload('e5176a52', component.options)
    }
    module.hot.accept("./TabDeclaracionesDuenoBeneficiario.vue?vue&type=template&id=e5176a52&scoped=true", function () {
      api.rerender('e5176a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDeclaracionesDuenoBeneficiario.vue"
export default component.exports